// src/api.js
//
// Catalogue reads and enquiry submission. The catalogue routes are public and
// only ever return available stock - a sold unit 404s exactly like one that
// never existed.

const BASE = process.env.REACT_APP_API_URL;

async function get(path) {
  const res = await fetch(`${BASE}${path}`);
  if (res.status === 404) return null;
  if (!res.ok) throw new Error("load_failed");
  return res.json();
}

// The whole floor in one read. Search, category and sort all run in the
// browser - at up to 100 units that is instant, and every filter change
// costs no round trip. Past 100 this needs to move server side.
export async function getStock() {
  const d = await get("/v1/requip?limit=100");
  return d?.items || [];
}

export async function getCategories() {
  const d = await get("/v1/requip/categories");
  return d?.categories || [];
}

// null when sold, hidden or unknown
export async function getItem(slug) {
  const d = await get(`/v1/requip/${encodeURIComponent(slug)}`);
  return d?.item || null;
}

// ---------------------------------------------------------------------------
// Same contract as the other sites: the API commits the row before it sends
// the notification, so a 201 means the enquiry is stored.
export async function submitEnquiry(payload) {
  const res = await fetch(`${BASE}/v1/enquiries`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  if (res.ok) return res.json();

  let code = "unknown";
  try {
    const body = await res.json();
    code = body.error || code;
  } catch {
    // non-JSON response, keep the default
  }

  const messages = {
    verification_failed: "The security check did not pass. Please try again.",
    email_or_phone_required: "Please give either an email address or a phone number.",
  };

  const err = new Error(
    messages[code] ||
      (res.status === 429
        ? "Too many enquiries from this connection. Please wait a minute and try again."
        : "Something went wrong sending your enquiry. Please call us instead.")
  );
  err.code = code;
  throw err;
}